// src/pages/Produtos/profiles/produto.js
export const produtoProfile = {
    id: 'produto',
    layout: 'produto',
    tabs: {
        cabecalho: { enabled: true },
        industria: { enabled: true },
        materiaPrima: { enabled: true },
        modoProducao: { enabled: true },
        embalagens: { enabled: true },
        caracteristicas: { enabled: true },
        bens: { enabled: true }, // porque “produto” pode virar bem? você decide; se não, desliga
        mobilia: { enabled: false },
        imagens: { enabled: true },
    },

    uiTabs: {
        embalagem: {},
        bens: {
            show: { veiculo: false, imovel: false, bemMovel: true },
        },
        caracteristicas: {
            titles: {
                grid: 'Informações técnicas do produto',
            },
            labels: { grid: 'Informações técnicas do produto' },
        },
    },

    parametros: {
        sanitize: {
            keepChildren: ['Empresa', 'NCM', 'Fabricante', 'produtoEmbalagens', 'produtoImagens', 'produtoBens', 'produtoComposicoes', 'produtoCores', 'tabelaPrecoItems'],
        },
    },
};
